/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import styles from './SendNewsletterForm.module.css'
import { emailRegexp } from 'shared-code/regexp'
import { useForm } from 'react-hook-form'
import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import Check from 'shared-svg/Check.svg'

interface SendNewsletterFormProps extends BasicStyledComponent {
  placeholder: string
  button: string
  active: boolean
  onSubmit: (email: string) => Promise<boolean>
}

const SendNewsletterForm: React.VFC<SendNewsletterFormProps> = ({
  placeholder,
  button,
  className,
  onSubmit,
  active,
}) => {
  const {
    reset,
    getValues,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ email: string }>({ mode: 'onTouched' })

  return (
    <form
      className={clsx(styles.container, className, { [styles.error]: errors.email })}
      onSubmit={handleSubmit(async () => {
        if (!active) {
          return
        }

        const { email } = getValues()
        const success = await onSubmit(email)
        if (!email || errors.email) {
          return
        }

        if (success) {
          reset()
        }
      })}
    >
      <input
        type="email"
        placeholder={placeholder}
        className={styles.input}
        {...register('email', { required: true, pattern: emailRegexp })}
      />
      <button type="submit" className={clsx(styles.button, { [styles.disabled]: !active })}>
        <span className={styles.buttonText}>{button}</span>
        <Check className={styles.buttonIcon} />
      </button>
    </form>
  )
}

export default SendNewsletterForm
